// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssModifiedImpactSchema = z.enum(['X','N','L','H'] as const);

export type CvssModifiedImpactType = `${z.infer<typeof CvssModifiedImpactSchema>}`

export default CvssModifiedImpactSchema;
